// https://cydstumpel.nl/

import * as THREE from 'three'
import { useRef } from 'react'
import { Canvas, useFrame } from '@react-three/fiber'
import { Image, Environment } from '@react-three/drei'
import { easing } from 'maath'
import './util'

const CARDS = [
  { url: '/brand/midnight-classic-card.svg', variant: 'classic' },
  { url: '/brand/cardano-classic-card.svg', variant: 'classic' },
  { url: '/img2_.png', variant: 'classic' },
  { url: '/img3_.png', variant: 'classic' },
  { url: '/img4_.png', variant: 'classic' },
  { url: '/brand/private-mode-card.svg', variant: 'classic' },
  { url: '/img5_.png', variant: 'classic' },
  { url: '/img6_.png', variant: 'classic' },
  { url: '/brand/unshielded-card.svg', variant: 'classic' },
  { url: '/img7_.png', variant: 'classic' },
  { url: '/img8_.png', variant: 'classic' },
  { url: '/img9_.png', variant: 'classic' },
  { url: '/img10_.png', variant: 'classic' },
  { url: '/img11_.png', variant: 'classic' },
  { url: '/img12_.png', variant: 'classic' },
  { url: '/img13_.png', variant: 'classic' },
  { url: '/img14_.png', variant: 'classic' },
]

export const App = ({ dark = false }) => (
  <Canvas camera={{ position: [0, 0.24, 9.5], fov: 13.2 }} dpr={[1, 1.5]} style={{ background: 'transparent' }}>
    <fog attach="fog" args={[dark ? '#0c0e12' : '#ffffff', 12.4, 20.8]} />
    <Rig rotation={[0, 0, 0.05]}>
      <Carousel />
    </Rig>
    <Environment preset={dark ? 'night' : 'city'} background={false} />
    <ambientLight intensity={dark ? 1.02 : 0.9} />
    <directionalLight position={[1.8, 2.6, 4.4]} intensity={dark ? 0.36 : 0.54} color={dark ? '#ffffff' : '#f5f5f5'} />
  </Canvas>
)

function Rig(props) {
  const ref = useRef()
  useFrame((state, delta) => {
    if (!ref.current) return
    const elapsed = state.clock.getElapsedTime()
    ref.current.rotation.y += delta * 0.135
    ref.current.rotation.z = 0.05 + Math.sin(elapsed * 0.18) * 0.02
    easing.damp3(state.camera.position, [Math.sin(elapsed * 0.16) * 0.54, Math.sin(elapsed * 0.24) * 0.08 + 0.22, 9.5], 0.32, delta)
    state.camera.lookAt(0, 0, 0)
  })
  return <group ref={ref} {...props} />
}

function Carousel({ radius = 1.72, count = CARDS.length }) {
  return Array.from({ length: count }, (_, i) => (
    <Card
      key={`${CARDS[i % CARDS.length].url}-${i}`}
      index={i}
      url={CARDS[i % CARDS.length].url}
      variant={CARDS[i % CARDS.length].variant}
      position={[
        Math.sin((i / count) * Math.PI * 2) * radius,
        Math.sin((i / count) * Math.PI * 4) * 0.11,
        Math.cos((i / count) * Math.PI * 2) * radius,
      ]}
      rotation={[0, Math.PI + (i / count) * Math.PI * 2, 0]}
    />
  ))
}

function Card({ url, index, position, variant, ...props }) {
  const ref = useRef()
  const baseY = position[1]

  useFrame((state, delta) => {
    if (!ref.current) return
    const elapsed = state.clock.getElapsedTime() + index * 0.4
    const variantScale = variant === 'midnight' ? 1.05 : 1
    const scale = variantScale + Math.sin(elapsed * 0.44) * 0.012
    ref.current.position.y = baseY + Math.sin(elapsed * 0.62) * (variant === 'midnight' ? 0.055 : 0.034)
    ref.current.rotation.z = Math.sin(elapsed * 0.28) * (variant === 'midnight' ? 0.026 : 0.016)
    easing.damp3(ref.current.scale, [scale, scale, scale], 0.18, delta)
  })

  return (
    <Image
      ref={ref}
      url={url}
      position={position}
      transparent
      side={THREE.DoubleSide}
      {...props}
      fit="cover"
      zoom={variant === 'midnight' ? 1.04 : 1}
      anisotropy={32}
    >
      <bentPlaneGeometry args={[0.07, 0.58, 0.84, 24, 24]} />
    </Image>
  )
}
